export default __webpack_public_path__ + "static/media/valutamarkets-dark.26828867.png";